import { render, staticRenderFns } from "./VacationDetailsListMob.vue?vue&type=template&id=2ad89836&scoped=true&"
import script from "./VacationDetailsListMob.vue?vue&type=script&lang=js&"
export * from "./VacationDetailsListMob.vue?vue&type=script&lang=js&"
import style0 from "./VacationDetailsListMob.vue?vue&type=style&index=0&id=2ad89836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad89836",
  null
  
)

export default component.exports